<template>
  <el-select
    v-model="value"
    v-bind="$attrs"
    placeholder="Filtro por tipo de solicitud"
    size="mini"
    clearable
    filterable
    @change="handleChange"
    @input="$emit('update:type', $event)"
  >
    <el-option
      v-for="t in request_types"
      :key="t.value"
      :value="t.value"
      :label="t.label"
    />
  </el-select>
</template>

<script>
export default {
  name: "RequestTypeSelector",
  props: {
    type: {
      type: [Number, String],
      required: false,
      default: null
    },
    internal: {
      type: Boolean,
      default: false
    }
  },
  created() {
    this.value = this.type;
  },
  data() {
    return {
      value: null
    };
  },
  computed: {
    request_types() {
      if (this.internal) {
        return this.$store.getters[
          "request_types/getInternalRequestTypesSelector"
        ];
      }
      return this.$store.getters[
        "request_types/getExternalRequestTypesSelector"
      ];
    }
  },
  methods: {
    handleChange(val) {
      this.$emit("update:type", val);
      this.$emit("change", val);
    }
  }
};
</script>
